import { render } from "./MainContent.vue?vue&type=template&id=78395acf"
const script = {}
script.render = render

export default script